import { createSlice } from '@reduxjs/toolkit';
import { getSupplierServices } from './thunks';
import { logOut } from '../authentication/authenticationSlice';

const initialState = {
  servicesBySupplier: {},
  loading: 'idle',
  error: null
};

const supplierServicesSlice = createSlice({
  name: 'supplierServices',
  initialState,
  reducers: {
    clearSupplierServicesError: (state) => {
      state.error = null;
      state.loading = 'idle';
    }
  },
  extraReducers: {
    [getSupplierServices.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getSupplierServices.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      if (action.payload && action.meta && action.meta.arg) {
        const supplierId = action.meta.arg.param || action.meta.arg;
        state.servicesBySupplier[supplierId] = Array.isArray(action.payload)
          ? action.payload
          : (action.payload.value || []);
      }
    },
    [getSupplierServices.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error ? action.error.message : 'Error';
    },
    [logOut]: () => initialState
  }
});

export const { clearSupplierServicesError } = supplierServicesSlice.actions;
export default supplierServicesSlice.reducer;
